import Commands from './commands';

class MulBy extends Commands {
    constructor(registry) {
        super("mulBy", registry);
    }

    async execute(node, emitter, options) {
        const key = await emitter(node.params[0], options);
        const multiplyBy = parseFloat(await emitter(node.params[1], options));
        const value = parseFloat(this.registry.get(key));
        this.registry.set(key, value * multiplyBy);
        return value * multiplyBy;
    }
}

export default MulBy;
